import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState, useRef, useCallback, useEffect } from 'react';

function useHover() {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      hovered = _useState2[0],
      setHovered = _useState2[1];

  var ref = useRef(null);
  var onMouseEnter = useCallback(function () {
    return setHovered(true);
  }, []);
  var onMouseLeave = useCallback(function () {
    return setHovered(false);
  }, []);
  useEffect(function () {
    if (ref.current) {
      ref.current.addEventListener("mouseenter", onMouseEnter);
      ref.current.addEventListener("mouseleave", onMouseLeave);
      return function () {
        var _a, _b;

        (_a = ref.current) == null ? void 0 : _a.removeEventListener("mouseenter", onMouseEnter);
        (_b = ref.current) == null ? void 0 : _b.removeEventListener("mouseleave", onMouseLeave);
      };
    }

    return void 0;
  }, []);
  return {
    ref: ref,
    hovered: hovered
  };
}

export { useHover };